export function ServiceTerms() {
  return (
    <div className="prose max-w-3xl mx-auto py-12 px-4">
      <h1>서비스 이용약관</h1>
      <h2>제1조 (목적)</h2>
      <p>
        본 약관은 A-Blind(이하 “회사”)가 제공하는 서비스의 이용과 관련하여
        회사와 회원 간의 권리와 의무, 책임사항 등을 규정함을 목적으로 합니다.
      </p>
      <h2>제2조 (회원가입 및 이용계약)</h2>
      <ul>
        <li>회원은 회사가 정한 절차에 따라 가입신청을 하며, 회사가 이를 승인함으로써 계약이 성립됩니다.</li>
        <li>회사는 회원의 자격 및 정보의 정확성 여부에 따라 가입을 거절하거나 제한할 수 있습니다.</li>
      </ul>
      <h2>제3조 (서비스 이용)</h2>
      <ul>
        <li>회원은 회사가 제공하는 콘텐츠 및 커뮤니티 기능을 자유롭게 이용할 수 있습니다.</li>
        <li>일부 기능은 정회원(등업 승인 후)만 이용 가능합니다.</li>
      </ul>
      <h2>제4조 (회원의 의무)</h2>
      <ul>
        <li>회원은 타인의 정보를 도용하거나 부정한 목적의 활동을 해서는 안 됩니다.</li>
        <li>회원은 회사가 제시한 운영정책을 따라야 합니다.</li>
      </ul>
      <h2>제5조 (계약 해지 및 이용제한)</h2>
      <p>
        회원이 본 약관을 위반하거나 허위정보를 등록한 경우, 회사는 이용계약을 해지하거나 서비스를 제한할 수 있습니다.
      </p>
    </div>
  );
}